import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    unselected: 'b-brand-1 c-grey-10 w-11.5 h-7.5',
    selected: 'bg-brand-10 c-white w-11.5 h-7.5',
  }
} satisfies RecursivePartial<FilterConfig['option']['tileSquare']>
